/**
 * Auth Components Exports
 * Phase 6: Frontend Application
 */

export { ProtectedRoute } from './protected-route';
export { UserMenu } from './user-menu';

